const mutations = {
    setUser(state, { userId, slug, roles }) {
        state.auth = {
            id: userId,
            slug: slug,
            roles: roles
        }
    }
}

export default mutations